import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IPurchaseOrder, POStatus } from "../../models/PurchaseOrder";
import { Fetch } from "../../shared/Fetch";
import { EmptyFilterPurchase, Filter, IFilterPurchase } from "./Filter";
import { ILogin, IPermissionProps } from "../../models/Login";
import { Edit } from "./Edit";
import { APW } from "./APW";
import { RBilling } from "./RBilling";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Details } from "./details/Details";
import { format } from "date-fns";
import { InvoiceTable } from "../invoiceTracking/Table";
//import { Table as TimeSheetTable } from "../showTimesheet/Table";
// import { ShowTimesheet } from '../showTimesheet';
import { Dialog } from "primereact/dialog";
import { GeneratePO } from "./GeneratePO";
import { CompanyDocumentUpload } from "./SendCompanyDetails";
import { ShowTimesheet } from "../showTimesheet";
import { SubVendorInvoices } from "../subVendorInvoices";
import { useNavigate } from "react-router-dom";
import { POStatusMap } from "../../models/FDropdown";


interface Iprops {
    setReload: (reload: boolean) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    isConsultant: boolean,
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IPurchaseOrder>, loading: boolean });
    const [filters, setFilters] = useState<IFilterPurchase>(EmptyFilterPurchase);
    const [invoiceLeft, setInvoiceLeft] = useState<number>(0);
    const [timesheetLeft, setTimesheetLeft] = useState<number>(0);
    const [consultantTimesheetLeft, setConsultantTimesheetLeft] = useState<number>(0);
    const [consultantInvoiceLeft, setConsultantInvoiceLeft] = useState<number>(0);

    const dt = useRef<any>(null);
    const navigate = useNavigate();

    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');


    const [edit, setEdit] = useState({ po: {}, open: false } as { po: IPurchaseOrder, open: boolean });
    const [details, setDetails] = useState({ po: {}, open: false } as { po: IPurchaseOrder, open: boolean });
    const hideEditDialog = () => {
        setEdit({ po: {}, open: false });
    };
    const hideDetailsDialog = () => {
        setDetails({ po: {}, open: false });
    };

    const [apw, setAPW] = useState({ po: {}, open: false } as { po: IPurchaseOrder, open: boolean });
    const hideAPWDialog = () => {
        setAPW({ po: {}, open: false });
    };
    const [rBilling, setRBilling] = useState({ po: {}, open: false } as { po: IPurchaseOrder, open: boolean });
    const [gInvoice, setGInvoice] = useState({ po: {}, open: false } as { po: IPurchaseOrder, open: boolean });
    const [timeSheet, setTimeSheet] = useState({ po: {}, open: false } as { po: IPurchaseOrder, open: boolean });
    const [modal2, setModal2] = useState({ singleData: {}, open: false } as { singleData: IPurchaseOrder, open: boolean });
    const [modal3, setModal3] = useState({ singleData: {}, open: false } as { singleData: IPurchaseOrder, open: boolean });

    const hideDialog2 = () => {
        setModal2({ singleData: {}, open: false });
        setModal3({ singleData: {}, open: false });


    }; const [showAction, setShowAction] = useState(0);

    const hideRBillingDialog = () => {
        setRBilling({ po: {}, open: false });
    };

    useEffect(() => {
        loadTableData();
    }, [filters, props.reload]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        let externalUserFilter = "";
        if (loginObj.user_Type === 2) {
            externalUserFilter = `&consultantUser=${loginObj.consultant_ID}&userType=${loginObj.user_Type}`;
        }
        if (loginObj.user_Type === 3) {
            externalUserFilter = `&subvendorUser=${loginObj.sub_Vendor_ID}&userType=${loginObj.user_Type}`;
        }
        const response = await Fetch("vwPODetailsExternalUser", "GET", null, `filter=${JSON.stringify(filters)}` + externalUserFilter, props.toast);
        if (response) {
            const data: Array<IPurchaseOrder> = await response.json();
            setTableData({ tableData: data, loading: false });
        }

        const response2 = await Fetch("vwPODetailsExternalUser/getTimesheetInvoiceLeft", "GET", null, `filter=${JSON.stringify(filters)}` + externalUserFilter, props.toast);
        if (response2) {
            const data: any = await response2.json();
            setInvoiceLeft(data.invoiceLeft);
            setTimesheetLeft(data.timesheetLeft);
            setConsultantTimesheetLeft(data.consultantTimesheetLeft);
            setConsultantInvoiceLeft(data.consultantInvoiceLeft);
        }
    }

    // const rightToolbarTemplate = () => {
    //     return (
    //         props.permissions.is_Export ?
    //             <React.Fragment>
    //                 {<div className="flex align-items-center justify-content-center">
    //                     <div>{invoiceLeft !== 0 && <h1 className="text-xl font-bold mr-5">Pending Invoices : <span style={{ color: 'red' }}>{invoiceLeft}</span></h1>}</div>
    //                     <div>{consultantInvoiceLeft !== 0 && <h1 className="text-xl font-bold mr-5">No. Of Consultants Whose Invoices are Pending : <span style={{ color: 'red' }}>{consultantInvoiceLeft}</span></h1>}</div>
    //                     <div>{timesheetLeft !== 0 && <h1 className="text-xl font-bold mr-5">Pending Timesheets : <span style={{ color: 'red' }}>{timesheetLeft}</span></h1>}</div>
    //                     <div>{consultantTimesheetLeft !== 0 && <h1 className="text-xl font-bold mr-5">No. Of Consultants Whose Timesheets are Pending : <span style={{ color: 'red' }}>{consultantTimesheetLeft}</span></h1>}</div>
    //                 </div>}
    //                 <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
    //             </React.Fragment> : (<div className="flex align-items-center justify-content-center">
    //                 <div>{invoiceLeft !== 0 && <h1 className="text-4xl font-bold mr-5">Pending Invoices : <span style={{ color: 'red' }}>{invoiceLeft}</span></h1>}</div>
    //                 <div>{timesheetLeft !== 0 && <h1 className="text-4xl font-bold mr-5">Pending Timesheets : <span style={{ color: 'red' }}>{timesheetLeft}</span></h1>}</div>
    //             </div>)
    //     );
    // };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Purchase Order</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const consultant_Name = (rowData: IPurchaseOrder) => {
        return (
            <span onClick={() => {
                if (props.permissions.is_Update && loginObj.user_Type === 1) setDetails({ po: rowData, open: true });
            }}
                className={props.permissions.is_Update ? "cursor-pointer text-cyan-700 underline" : ""}>
                {rowData.consultant_Name}
            </span>
        );
    }
    const pO_Status = (rowData: IPurchaseOrder) => {
        return (
            props.permissions.is_Update ?
                <span onClick={() => {
                    if (props.permissions.is_Update && loginObj.user_Type === 1) setEdit({ po: rowData, open: true });
                }}
                    className={props.permissions.is_Update ? "cursor-pointer text-cyan-700 underline" : ""}>
                    {rowData.pO_Status ? POStatusMap[rowData.pO_Status] : ''}
                </span>
                : <span>{rowData.pO_Status ? POStatusMap[rowData.pO_Status] : ''}</span>
        );
    };
    const actionBodyTemplate = (rowData: IPurchaseOrder) => {
        return (
            <>
                <Button label="APW" className="p-button-rounded p-button-info p-button-text" onClick={() => { if (rowData.pO_ID) setAPW({ po: rowData, open: true }) }} />
                <Button label="TimeSheet" tooltip="Add TimeSheet" className="p-button-rounded p-button-info p-button-text" onClick={() => { if (rowData.pO_ID) setTimeSheet({ po: rowData, open: true }) }} />
                {/* <Button label="Invoice" tooltip="Add Invoice" className="p-button-rounded p-button-info p-button-text" onClick={() => { if (rowData.pO_ID) setGInvoice({ po: rowData, open: true }) }} /> */}
                {/* <Button icon="pi pi-envelope" className="p-button-rounded  p-button-text ml-2" onClick={() => openSendComapnyDetails(rowData)} tooltip="Upload Document" /> */}

            </>
        );
    };

    const sendCompanyDetail = (rowData: IPurchaseOrder) => {
        return (
            <>
                <span className="text-cyan-700 underline" style={{ cursor: "pointer" }} onClick={() => openSendComapnyDetails(rowData)} > Send Email</span>

            </>
        )
    }

    const onHide = () => {
        setGInvoice({ po: {}, open: false });
        setTimeSheet({ po: {}, open: false });
    };

    const openGeneratePO = (rowData: IPurchaseOrder) => {
        setModal2({ open: true, singleData: rowData });

    }
    const openSendComapnyDetails = (rowData: IPurchaseOrder) => {
        setModal3({ open: true, singleData: rowData });

    }

    const goToDashboard = () => {
        navigate("/dashboard");
    };

    const rightToolbarTemplate = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            {/* <p className="w-full flex justify-content-between pr-2"><span></span><span></span><Button className="w-12rem" label="Go to Dashboard" onClick={goToDashboard} icon="pi pi-arrow-left" /></p> */}
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const leftToolbarTemplate = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            {/* <p className="w-full flex justify-content-between pr-2"><span>Show My Projects</span><span></span></p> */}
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate} left={leftToolbarTemplate}></Toolbar>
            {props.isConsultant === false && <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IFilterPurchase) => setFilters(filters)} />
                </AccordionTab>
            </Accordion>}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                {/* <Column field="company_Name_Sales" header="Company Name" /> */}
                <Column field="salesmanager" header="Sales Manager" body={(rowData) => <p style={{ color: rowData.sales_Status ? "red" : "" }}>{(rowData.salesmanager || "").split("-")[0]}</p>} />
                {/* <Column field="sales_Company_Branch" header="Sales Comp (Branch)" sortable /> */}
                <Column field="user_Name" header="Recruiter" body={(rowData) => <p style={{ color: rowData.recruiter_Status ? "red" : "" }}>{(rowData.user_Name || "").split("-")[0]}</p>} />
                {/* <Column field="recruiter_Company_Branch" header="Recruiter Comp (Branch)" sortable /> */}
                <Column header="Consultant Name" body={consultant_Name} />
                <Column field="req_CategoryName" header="Skill Category" style={{ maxWidth: "8rem", overflow: "hidden" }} />
                <Column field="project_Client_Name" header="End Client" />
                <Column field="project_Start_Date1" header="Start Date" body={(rowData: any) => <p>{(rowData.project_Start_Date1 || "").split('-')[1]}-{(rowData.project_Start_Date1 || "").split('-')[2]}-{(rowData.project_Start_Date1 || "").split('-')[0]}</p>} />
                <Column field="project_End_Date1" header="End Date" body={(rowData: any) => <p>{(rowData.project_End_Date1 || "").split('-')[1]}-{(rowData.project_End_Date1 || "").split('-')[2]}-{(rowData.project_End_Date1 || "").split('-')[0]}</p>} />
                {/* <Column field="bRate" header="B Rate" /> */}
                {/* {!(_roles.includes(30) || _roles.includes(31)) && <Column field="sRate" header="S Rate" />} */}
                {/* {!(_roles.includes(30) || _roles.includes(31)) && <Column field="mRate" header="Margin " />} */}
                {/* {!(_roles.includes(30) || _roles.includes(31)) && <Column field="vendor_Company_Name" header="Vendor Company" />} */}
                {/* {!(_roles.includes(30) || _roles.includes(31)) && <Column header="Sub Vendor" body={(e) => e.pO_Sub_Vendor_Company !== null ? <p>{e.pO_Sub_Vendor_Company}</p> : <p>{e.sub_Vendor_Company}</p>} />} */}
                <Column field="pO_Date1" header="PO Date" body={(rowData: any) => <p>{(rowData.pO_Date1 || "").split('/')[1]}-{(rowData.pO_Date1 || "").split('/')[0]}-{(rowData.pO_Date1 || "").split('/')[2]}</p>} />
                <Column field="pO_Status" header="Status" body={pO_Status} />
                {/* {!(_roles.includes(30) || _roles.includes(31)) && <Column field="referred_By" header="Referred By" />} */}
                {/* {(_roles.includes(1)) && <Column field="" header="Send Mail" body={sendCompanyDetail} />} */}

                <Column header="Action" body={actionBodyTemplate} />
            </DataTable>
            <Edit open={edit.open} hideDialog={hideEditDialog} po={edit.po} toast={props.toast} reload={props.reload} setReload={props.setReload} />
            <APW open={apw.open} hideDialog={hideAPWDialog} po={apw.po} isConsultant={props?.isConsultant || false} toast={props.toast} />
            <RBilling open={rBilling.open} hideDialog={hideRBillingDialog} po={rBilling.po} toast={props.toast} />
            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setFilters={(filters: IFilterPurchase | null) => setFilters(filters)} /> */}
            <Details open={details.open} hideDialog={hideDetailsDialog} po={details.po} toast={props.toast} reload={props.reload} setReload={props.setReload} ></Details>
            <Dialog visible={gInvoice.open} style={{ width: '80vw' }} header="Add/Update Invoice" className="p-fluid" onHide={onHide}>
                {/* <InvoiceTable toast={props.toast} permissions={props.permissions} po={gInvoice.po} /> */}
                <SubVendorInvoices isConsultant={props?.isConsultant || false} poID={gInvoice.po} />
            </Dialog>
            <Dialog visible={timeSheet.open} style={{ width: '80vw' }} header="Add/Update TimeSheet" className="p-fluid" onHide={onHide}>
                <ShowTimesheet isConsultant={props?.isConsultant || false} is_Create={props.permissions.is_Create} is_Delete={props.permissions.is_Delete} is_Update={props.permissions.is_Update} is_Export={props.permissions.is_Export} is_View={props.permissions.is_View} po={timeSheet.po} subVendor={true} />
            </Dialog>
            {/* <GeneratePO singleData={modal2.singleData} open={modal2.open} hideDialog={hideDialog2} toast={props.toast}></GeneratePO> */}
            {/* <CompanyDocumentUpload singleData={modal3.singleData} open={modal3.open} hideDialog={hideDialog2} toast={props.toast} /> */}

        </>
    );
}
